import React from "react";
import PropTypes from "prop-types";
import Icon from "../../Icon";
import { PanelControlTooltip, PanelControl } from "../styles/SideNav.styles";

/**
 * Close button for the expanded panel. Shown inside the panel with a tooltip "Close panel".
 */
const PanelControlComponent = ({ onClick }) => {
  return (
    <PanelControlTooltip
      ariaLabel="Close panel"
      text="Close panel"
      direction="left"
      position="absolute"
      width="fit-content"
      tabIndex="-1"
      id="panel-control-tooltip"
    >
      <PanelControl type="button" onClick={onClick} aria-label="Close panel">
        <Icon icon={["fas", "times"]} size="sm" />
      </PanelControl>
    </PanelControlTooltip>
  );
};

PanelControlComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PanelControlComponent;
